export var CacheControlScope;
(function (CacheControlScope) {
    CacheControlScope["Private"] = "PRIVATE";
    CacheControlScope["Public"] = "PUBLIC";
})(CacheControlScope || (CacheControlScope = {}));
export var CarlineStructureMode;
(function (CarlineStructureMode) {
    CarlineStructureMode["Automatic"] = "AUTOMATIC";
    CarlineStructureMode["Manual"] = "MANUAL";
})(CarlineStructureMode || (CarlineStructureMode = {}));
export var CentralRewardType;
(function (CentralRewardType) {
    CentralRewardType["Audicharging"] = "AUDICHARGING";
    CentralRewardType["Audicharginghub"] = "AUDICHARGINGHUB";
    CentralRewardType["Audidriving"] = "AUDIDRIVING";
    CentralRewardType["Audithemes"] = "AUDITHEMES";
    CentralRewardType["Audiwilderness"] = "AUDIWILDERNESS";
    CentralRewardType["Empty"] = "EMPTY";
    CentralRewardType["Fod"] = "FOD";
})(CentralRewardType || (CentralRewardType = {}));
export var ChallengeState;
(function (ChallengeState) {
    ChallengeState["Activated"] = "ACTIVATED";
    ChallengeState["Available"] = "AVAILABLE";
    ChallengeState["Canceled"] = "CANCELED";
    ChallengeState["Failed"] = "FAILED";
    ChallengeState["Succeeded"] = "SUCCEEDED";
    ChallengeState["Switched"] = "SWITCHED";
})(ChallengeState || (ChallengeState = {}));
export var ConfiguredCarFeatureGroup;
(function (ConfiguredCarFeatureGroup) {
    ConfiguredCarFeatureGroup["Accessories"] = "ACCESSORIES";
    ConfiguredCarFeatureGroup["BodyColor"] = "BODY_COLOR";
    ConfiguredCarFeatureGroup["ExclusiveExteriorColors"] = "EXCLUSIVE_EXTERIOR_COLORS";
    ConfiguredCarFeatureGroup["ExteriorColors"] = "EXTERIOR_COLORS";
    ConfiguredCarFeatureGroup["InteriorTiles"] = "INTERIOR_TILES";
    ConfiguredCarFeatureGroup["Lights"] = "LIGHTS";
    ConfiguredCarFeatureGroup["Rims"] = "RIMS";
    ConfiguredCarFeatureGroup["RoofColor"] = "ROOF_COLOR";
    ConfiguredCarFeatureGroup["Seats"] = "SEATS";
    ConfiguredCarFeatureGroup["SteeringWheels"] = "STEERING_WHEELS";
})(ConfiguredCarFeatureGroup || (ConfiguredCarFeatureGroup = {}));
export var ConfiguredCarFeatureState;
(function (ConfiguredCarFeatureState) {
    ConfiguredCarFeatureState["Available"] = "available";
    ConfiguredCarFeatureState["Changeable"] = "changeable";
    ConfiguredCarFeatureState["InConflict"] = "inConflict";
    ConfiguredCarFeatureState["Selected"] = "selected";
    ConfiguredCarFeatureState["Standard"] = "standard";
})(ConfiguredCarFeatureState || (ConfiguredCarFeatureState = {}));
export var ConfiguredCarFeatureType;
(function (ConfiguredCarFeatureType) {
    ConfiguredCarFeatureType["Accessory"] = "ACCESSORY";
    ConfiguredCarFeatureType["BodyColor"] = "BODY_COLOR";
    ConfiguredCarFeatureType["Equipment"] = "EQUIPMENT";
    ConfiguredCarFeatureType["EquipmentContent"] = "EQUIPMENT_CONTENT";
    ConfiguredCarFeatureType["ExclusiveExteriorColor"] = "EXCLUSIVE_EXTERIOR_COLOR";
    ConfiguredCarFeatureType["ExteriorColor"] = "EXTERIOR_COLOR";
    ConfiguredCarFeatureType["InteriorTile"] = "INTERIOR_TILE";
    ConfiguredCarFeatureType["Model"] = "MODEL";
    ConfiguredCarFeatureType["RawInteriorColor"] = "RAW_INTERIOR_COLOR";
    ConfiguredCarFeatureType["RoofColor"] = "ROOF_COLOR";
    ConfiguredCarFeatureType["Stealth"] = "STEALTH";
    ConfiguredCarFeatureType["Trimline"] = "TRIMLINE";
})(ConfiguredCarFeatureType || (ConfiguredCarFeatureType = {}));
export var ConfiguredCarFeatureVendor;
(function (ConfiguredCarFeatureVendor) {
    ConfiguredCarFeatureVendor["Audi"] = "AUDI";
    ConfiguredCarFeatureVendor["AudiSport"] = "AUDI_SPORT";
})(ConfiguredCarFeatureVendor || (ConfiguredCarFeatureVendor = {}));
export var ConfiguredCarStaticFeatureKind;
(function (ConfiguredCarStaticFeatureKind) {
    ConfiguredCarStaticFeatureKind["BodyColor"] = "BODY_COLOR";
    ConfiguredCarStaticFeatureKind["ExclusivExteriorColor"] = "EXCLUSIV_EXTERIOR_COLOR";
    ConfiguredCarStaticFeatureKind["ExteriorColor"] = "EXTERIOR_COLOR";
    ConfiguredCarStaticFeatureKind["InteriorColor"] = "INTERIOR_COLOR";
    ConfiguredCarStaticFeatureKind["Option"] = "OPTION";
    ConfiguredCarStaticFeatureKind["RoofColor"] = "ROOF_COLOR";
    ConfiguredCarStaticFeatureKind["Standard"] = "STANDARD";
})(ConfiguredCarStaticFeatureKind || (ConfiguredCarStaticFeatureKind = {}));
export var ConfiguredCarsFromNaturalLanguageConfigurationScopeTypesInput;
(function (ConfiguredCarsFromNaturalLanguageConfigurationScopeTypesInput) {
    ConfiguredCarsFromNaturalLanguageConfigurationScopeTypesInput["Carline"] = "CARLINE";
})(ConfiguredCarsFromNaturalLanguageConfigurationScopeTypesInput || (ConfiguredCarsFromNaturalLanguageConfigurationScopeTypesInput = {}));
export var ConfiguredCarsFromNaturalLanguageResponseErrorCodes;
(function (ConfiguredCarsFromNaturalLanguageResponseErrorCodes) {
    ConfiguredCarsFromNaturalLanguageResponseErrorCodes["BadUserInput"] = "BAD_USER_INPUT";
    ConfiguredCarsFromNaturalLanguageResponseErrorCodes["NoConfigurationsFound"] = "NO_CONFIGURATIONS_FOUND";
    ConfiguredCarsFromNaturalLanguageResponseErrorCodes["NoUglyCars"] = "NO_UGLY_CARS";
})(ConfiguredCarsFromNaturalLanguageResponseErrorCodes || (ConfiguredCarsFromNaturalLanguageResponseErrorCodes = {}));
export var ContrastThemeHint;
(function (ContrastThemeHint) {
    ContrastThemeHint["Dark"] = "DARK";
    ContrastThemeHint["Light"] = "LIGHT";
})(ContrastThemeHint || (ContrastThemeHint = {}));
export var CustomerGroupClassification;
(function (CustomerGroupClassification) {
    CustomerGroupClassification["Private"] = "PRIVATE";
    CustomerGroupClassification["SmallCommercial"] = "SMALL_COMMERCIAL";
})(CustomerGroupClassification || (CustomerGroupClassification = {}));
export var DealerSearchSortDirection;
(function (DealerSearchSortDirection) {
    DealerSearchSortDirection["Asc"] = "ASC";
    DealerSearchSortDirection["Desc"] = "DESC";
})(DealerSearchSortDirection || (DealerSearchSortDirection = {}));
export var Drive;
(function (Drive) {
    Drive["FrontWheelDrive"] = "FRONT_WHEEL_DRIVE";
    Drive["Quattro"] = "QUATTRO";
    Drive["RearWheelDrive"] = "REAR_WHEEL_DRIVE";
})(Drive || (Drive = {}));
export var DriveTrain;
(function (DriveTrain) {
    DriveTrain["Bev"] = "BEV";
    DriveTrain["Ice"] = "ICE";
    DriveTrain["Mhev"] = "MHEV";
    DriveTrain["Phev"] = "PHEV";
})(DriveTrain || (DriveTrain = {}));
export var EcoLabel;
(function (EcoLabel) {
    EcoLabel["Eco"] = "ECO";
    EcoLabel["EcoIt"] = "ECO_IT";
    EcoLabel["NoEco"] = "NO_ECO";
    EcoLabel["Zero"] = "ZERO";
})(EcoLabel || (EcoLabel = {}));
export var EngineInput;
(function (EngineInput) {
    EngineInput["Electric"] = "ELECTRIC";
    EngineInput["Gasoline"] = "GASOLINE";
    EngineInput["Hybrid"] = "HYBRID";
})(EngineInput || (EngineInput = {}));
export var EngineTechnology;
(function (EngineTechnology) {
    EngineTechnology["Tdi"] = "TDI";
    EngineTechnology["Tfsi"] = "TFSI";
    EngineTechnology["Tfsie"] = "TFSIE";
})(EngineTechnology || (EngineTechnology = {}));
export var EngineType;
(function (EngineType) {
    EngineType["Combustion"] = "COMBUSTION";
    EngineType["Electrical"] = "ELECTRICAL";
    EngineType["Hybrid"] = "HYBRID";
})(EngineType || (EngineType = {}));
export var FeatureChangeAction;
(function (FeatureChangeAction) {
    FeatureChangeAction["Add"] = "ADD";
    FeatureChangeAction["Remove"] = "REMOVE";
})(FeatureChangeAction || (FeatureChangeAction = {}));
export var FilterMode;
(function (FilterMode) {
    FilterMode["Exclusive"] = "EXCLUSIVE";
    FilterMode["Inclusive"] = "INCLUSIVE";
})(FilterMode || (FilterMode = {}));
export var FilterModeInput;
(function (FilterModeInput) {
    FilterModeInput["Exclusive"] = "EXCLUSIVE";
    FilterModeInput["Inclusive"] = "INCLUSIVE";
})(FilterModeInput || (FilterModeInput = {}));
export var FuelType;
(function (FuelType) {
    FuelType["Cng"] = "CNG";
    FuelType["Diesel"] = "DIESEL";
    FuelType["Electrical"] = "ELECTRICAL";
    FuelType["Electricity"] = "ELECTRICITY";
    FuelType["Hybrid"] = "HYBRID";
    FuelType["Petrol"] = "PETROL";
})(FuelType || (FuelType = {}));
export var Gear;
(function (Gear) {
    Gear["Automatic"] = "AUTOMATIC";
    Gear["FiveSpeed"] = "FIVE_SPEED";
    Gear["SixSpeed"] = "SIX_SPEED";
    Gear["Stronic"] = "STRONIC";
    Gear["Tiptronic"] = "TIPTRONIC";
})(Gear || (Gear = {}));
export var GearType;
(function (GearType) {
    GearType["Automatic"] = "AUTOMATIC";
    GearType["Manual"] = "MANUAL";
})(GearType || (GearType = {}));
export var MeasurementPhaseNonWltp;
(function (MeasurementPhaseNonWltp) {
    MeasurementPhaseNonWltp["City"] = "CITY";
    MeasurementPhaseNonWltp["Combined"] = "COMBINED";
    MeasurementPhaseNonWltp["Highway"] = "HIGHWAY";
})(MeasurementPhaseNonWltp || (MeasurementPhaseNonWltp = {}));
export var OneGraphServiceContactRoleEnum;
(function (OneGraphServiceContactRoleEnum) {
    OneGraphServiceContactRoleEnum["Developer"] = "DEVELOPER";
    OneGraphServiceContactRoleEnum["ProductOwner"] = "PRODUCT_OWNER";
    OneGraphServiceContactRoleEnum["ProxyProductOwner"] = "PROXY_PRODUCT_OWNER";
    OneGraphServiceContactRoleEnum["Support"] = "SUPPORT";
})(OneGraphServiceContactRoleEnum || (OneGraphServiceContactRoleEnum = {}));
export var OneGraphServiceStatusEnum;
(function (OneGraphServiceStatusEnum) {
    OneGraphServiceStatusEnum["Fail"] = "FAIL";
    OneGraphServiceStatusEnum["Pass"] = "PASS";
    OneGraphServiceStatusEnum["Warn"] = "WARN";
})(OneGraphServiceStatusEnum || (OneGraphServiceStatusEnum = {}));
export var RenderedImagesConvertibleRoof;
(function (RenderedImagesConvertibleRoof) {
    RenderedImagesConvertibleRoof["Closed"] = "CLOSED";
    RenderedImagesConvertibleRoof["Open"] = "OPEN";
})(RenderedImagesConvertibleRoof || (RenderedImagesConvertibleRoof = {}));
export var RenderedImagesDeviceType;
(function (RenderedImagesDeviceType) {
    RenderedImagesDeviceType["Desktop"] = "DESKTOP";
    RenderedImagesDeviceType["Mobile"] = "MOBILE";
})(RenderedImagesDeviceType || (RenderedImagesDeviceType = {}));
export var RenderedImagesFilterCategory;
(function (RenderedImagesFilterCategory) {
    RenderedImagesFilterCategory["Exterior"] = "EXTERIOR";
    RenderedImagesFilterCategory["Interior"] = "INTERIOR";
    RenderedImagesFilterCategory["Lights"] = "LIGHTS";
    RenderedImagesFilterCategory["Unknown"] = "UNKNOWN";
})(RenderedImagesFilterCategory || (RenderedImagesFilterCategory = {}));
export var RenderedImagesFilterView;
(function (RenderedImagesFilterView) {
    RenderedImagesFilterView["Dashboard"] = "DASHBOARD";
    RenderedImagesFilterView["Front"] = "FRONT";
    RenderedImagesFilterView["Front3_4"] = "FRONT3_4";
    RenderedImagesFilterView["Frontseats"] = "FRONTSEATS";
    RenderedImagesFilterView["Headlight"] = "HEADLIGHT";
    RenderedImagesFilterView["Lights"] = "LIGHTS";
    RenderedImagesFilterView["Parallel"] = "PARALLEL";
    RenderedImagesFilterView["Rear"] = "REAR";
    RenderedImagesFilterView["Rear3_4"] = "REAR3_4";
    RenderedImagesFilterView["Rearseats"] = "REARSEATS";
    RenderedImagesFilterView["Rim"] = "RIM";
    RenderedImagesFilterView["Seats"] = "SEATS";
    RenderedImagesFilterView["Side"] = "SIDE";
    RenderedImagesFilterView["Unknown"] = "UNKNOWN";
    RenderedImagesFilterView["Wheels"] = "WHEELS";
})(RenderedImagesFilterView || (RenderedImagesFilterView = {}));
export var RepairCode;
(function (RepairCode) {
    RepairCode["AozChanged"] = "AOZ_CHANGED";
    RepairCode["AozDropped"] = "AOZ_DROPPED";
    RepairCode["AozNameChanged"] = "AOZ_NAME_CHANGED";
    RepairCode["AozPriceChanged"] = "AOZ_PRICE_CHANGED";
    RepairCode["BaseModelChange"] = "BASE_MODEL_CHANGE";
    RepairCode["ChangedSalesgroup"] = "CHANGED_SALESGROUP";
    RepairCode["ExtcolorChanged"] = "EXTCOLOR_CHANGED";
    RepairCode["ExtcolorChangedName"] = "EXTCOLOR_CHANGED_NAME";
    RepairCode["ExtcolorChangedPrice"] = "EXTCOLOR_CHANGED_PRICE";
    RepairCode["IncentiveDropped"] = "INCENTIVE_DROPPED";
    RepairCode["IntcolorChanged"] = "INTCOLOR_CHANGED";
    RepairCode["IntcolorChangedName"] = "INTCOLOR_CHANGED_NAME";
    RepairCode["ModelChangedPrice"] = "MODEL_CHANGED_PRICE";
    RepairCode["ModelChangedVersion"] = "MODEL_CHANGED_VERSION";
    RepairCode["ModelIsForbidden"] = "MODEL_IS_FORBIDDEN";
    RepairCode["ModelIsHidden"] = "MODEL_IS_HIDDEN";
    RepairCode["ModelNameChange"] = "MODEL_NAME_CHANGE";
    RepairCode["NewModelyear"] = "NEW_MODELYEAR";
    RepairCode["OptionAddedDueToConflict"] = "OPTION_ADDED_DUE_TO_CONFLICT";
    RepairCode["OptionChangedPrice"] = "OPTION_CHANGED_PRICE";
    RepairCode["OptionDropped"] = "OPTION_DROPPED";
    RepairCode["OptionDroppedDueToConflict"] = "OPTION_DROPPED_DUE_TO_CONFLICT";
    RepairCode["OptionNowStandard"] = "OPTION_NOW_STANDARD";
    RepairCode["TrimlineChangedExtension"] = "TRIMLINE_CHANGED_EXTENSION";
})(RepairCode || (RepairCode = {}));
export var RewardCategory;
(function (RewardCategory) {
    RewardCategory["Central"] = "CENTRAL";
    RewardCategory["Dealer"] = "DEALER";
})(RewardCategory || (RewardCategory = {}));
export var SelectedFinanceablePartType;
(function (SelectedFinanceablePartType) {
    SelectedFinanceablePartType["Accessory"] = "ACCESSORY";
    SelectedFinanceablePartType["Equipment"] = "EQUIPMENT";
    SelectedFinanceablePartType["Exterior"] = "EXTERIOR";
    SelectedFinanceablePartType["Interior"] = "INTERIOR";
    SelectedFinanceablePartType["Package"] = "PACKAGE";
})(SelectedFinanceablePartType || (SelectedFinanceablePartType = {}));
export var SimilarCarCompareCriterionStatus;
(function (SimilarCarCompareCriterionStatus) {
    SimilarCarCompareCriterionStatus["Additional"] = "additional";
    SimilarCarCompareCriterionStatus["Missing"] = "missing";
})(SimilarCarCompareCriterionStatus || (SimilarCarCompareCriterionStatus = {}));
export var SimilarCarsScoreTypeCriterion;
(function (SimilarCarsScoreTypeCriterion) {
    SimilarCarsScoreTypeCriterion["All"] = "ALL";
    SimilarCarsScoreTypeCriterion["CosAll"] = "COS_ALL";
    SimilarCarsScoreTypeCriterion["FeatureColorExt"] = "FEATURE_COLOR_EXT";
})(SimilarCarsScoreTypeCriterion || (SimilarCarsScoreTypeCriterion = {}));
export var SimilarCarsSortCriterion;
(function (SimilarCarsSortCriterion) {
    SimilarCarsSortCriterion["ColorOut"] = "COLOR_OUT";
    SimilarCarsSortCriterion["Distance"] = "DISTANCE";
    SimilarCarsSortCriterion["Price"] = "PRICE";
    SimilarCarsSortCriterion["Score"] = "SCORE";
})(SimilarCarsSortCriterion || (SimilarCarsSortCriterion = {}));
export var StaticEquipmentFeatureKind;
(function (StaticEquipmentFeatureKind) {
    StaticEquipmentFeatureKind["Accessory"] = "ACCESSORY";
    StaticEquipmentFeatureKind["BodyColor"] = "BODY_COLOR";
    StaticEquipmentFeatureKind["Equipment"] = "EQUIPMENT";
    StaticEquipmentFeatureKind["EquipmentContent"] = "EQUIPMENT_CONTENT";
    StaticEquipmentFeatureKind["ExclusiveExteriorColor"] = "EXCLUSIVE_EXTERIOR_COLOR";
    StaticEquipmentFeatureKind["ExteriorColor"] = "EXTERIOR_COLOR";
    StaticEquipmentFeatureKind["InteriorTile"] = "INTERIOR_TILE";
    StaticEquipmentFeatureKind["Model"] = "MODEL";
    StaticEquipmentFeatureKind["RawInteriorColor"] = "RAW_INTERIOR_COLOR";
    StaticEquipmentFeatureKind["RoofColor"] = "ROOF_COLOR";
    StaticEquipmentFeatureKind["Stealth"] = "STEALTH";
    StaticEquipmentFeatureKind["Trimline"] = "TRIMLINE";
})(StaticEquipmentFeatureKind || (StaticEquipmentFeatureKind = {}));
export var StaticEquipmentFeatureVendor;
(function (StaticEquipmentFeatureVendor) {
    StaticEquipmentFeatureVendor["Audi"] = "AUDI";
    StaticEquipmentFeatureVendor["AudiSport"] = "AUDI_SPORT";
})(StaticEquipmentFeatureVendor || (StaticEquipmentFeatureVendor = {}));
export var StockCarConsumptionAndEmissionHighlighting;
(function (StockCarConsumptionAndEmissionHighlighting) {
    StockCarConsumptionAndEmissionHighlighting["Detail"] = "DETAIL";
    StockCarConsumptionAndEmissionHighlighting["Extended"] = "EXTENDED";
    StockCarConsumptionAndEmissionHighlighting["Result"] = "RESULT";
})(StockCarConsumptionAndEmissionHighlighting || (StockCarConsumptionAndEmissionHighlighting = {}));
export var StockCarFeatureType;
(function (StockCarFeatureType) {
    StockCarFeatureType["Series"] = "SERIES";
    StockCarFeatureType["Special"] = "SPECIAL";
})(StockCarFeatureType || (StockCarFeatureType = {}));
export var StockCarFunctionOnDemandType;
(function (StockCarFunctionOnDemandType) {
    StockCarFunctionOnDemandType["FodLifetime"] = "FOD_LIFETIME";
    StockCarFunctionOnDemandType["FodRental"] = "FOD_RENTAL";
    StockCarFunctionOnDemandType["ServiceAndWearOem"] = "SERVICE_AND_WEAR_OEM";
    StockCarFunctionOnDemandType["ServiceAndWearVwfs"] = "SERVICE_AND_WEAR_VWFS";
    StockCarFunctionOnDemandType["ServiceContract"] = "SERVICE_CONTRACT";
})(StockCarFunctionOnDemandType || (StockCarFunctionOnDemandType = {}));
export var StockCarGeoDistanceUnitInput;
(function (StockCarGeoDistanceUnitInput) {
    StockCarGeoDistanceUnitInput["Kilometers"] = "KILOMETERS";
    StockCarGeoDistanceUnitInput["Miles"] = "MILES";
})(StockCarGeoDistanceUnitInput || (StockCarGeoDistanceUnitInput = {}));
export var StockCarSearchSortDirection;
(function (StockCarSearchSortDirection) {
    StockCarSearchSortDirection["Asc"] = "ASC";
    StockCarSearchSortDirection["Desc"] = "DESC";
})(StockCarSearchSortDirection || (StockCarSearchSortDirection = {}));
export var StockCarsType;
(function (StockCarsType) {
    StockCarsType["New"] = "NEW";
    StockCarsType["Used"] = "USED";
})(StockCarsType || (StockCarsType = {}));
export var StockCarsTypeCombinationInput;
(function (StockCarsTypeCombinationInput) {
    StockCarsTypeCombinationInput["New"] = "NEW";
    StockCarsTypeCombinationInput["NewAndUsed"] = "NEW_AND_USED";
    StockCarsTypeCombinationInput["NewOrUsed"] = "NEW_OR_USED";
    StockCarsTypeCombinationInput["Used"] = "USED";
})(StockCarsTypeCombinationInput || (StockCarsTypeCombinationInput = {}));
export var UserLevel;
(function (UserLevel) {
    UserLevel["Beginner"] = "BEGINNER";
    UserLevel["Bronze"] = "BRONZE";
    UserLevel["Gold"] = "GOLD";
    UserLevel["MaxLevel"] = "MAX_LEVEL";
    UserLevel["Platinum"] = "PLATINUM";
    UserLevel["Silver"] = "SILVER";
})(UserLevel || (UserLevel = {}));
export var VehicleBodyType;
(function (VehicleBodyType) {
    VehicleBodyType["Allroad"] = "ALLROAD";
    VehicleBodyType["Allstreet"] = "ALLSTREET";
    VehicleBodyType["Avant"] = "AVANT";
    VehicleBodyType["Cabriolet"] = "CABRIOLET";
    VehicleBodyType["Compact"] = "COMPACT";
    VehicleBodyType["Coupe"] = "COUPE";
    VehicleBodyType["Limousine"] = "LIMOUSINE";
    VehicleBodyType["Sportback"] = "SPORTBACK";
    VehicleBodyType["Suv"] = "SUV";
})(VehicleBodyType || (VehicleBodyType = {}));
export var VehicleType;
(function (VehicleType) {
    VehicleType["Bev"] = "BEV";
    VehicleType["Icev"] = "ICEV";
    VehicleType["Phev"] = "PHEV";
    VehicleType["Combustion"] = "combustion";
    VehicleType["Electric"] = "electric";
    VehicleType["HybridElectric"] = "hybridElectric";
    VehicleType["HybridGas"] = "hybridGas";
})(VehicleType || (VehicleType = {}));
export var WltpEnergyManagement;
(function (WltpEnergyManagement) {
    WltpEnergyManagement["Depleting"] = "DEPLETING";
    WltpEnergyManagement["Pure"] = "PURE";
    WltpEnergyManagement["Sustaining"] = "SUSTAINING";
    WltpEnergyManagement["Weighted"] = "WEIGHTED";
})(WltpEnergyManagement || (WltpEnergyManagement = {}));
export var WltpHybridElectricRangesEnergyManagement;
(function (WltpHybridElectricRangesEnergyManagement) {
    WltpHybridElectricRangesEnergyManagement["AllElectricRange"] = "ALL_ELECTRIC_RANGE";
    WltpHybridElectricRangesEnergyManagement["EquivAllElRange"] = "EQUIV_ALL_EL_RANGE";
})(WltpHybridElectricRangesEnergyManagement || (WltpHybridElectricRangesEnergyManagement = {}));
//# sourceMappingURL=onegraph.js.map